import { ETokenSymbols } from "types"

const isPageForClaim = (path: string) => {
  return path === `/${ETokenSymbols.eth}` ||
         path === `/${ETokenSymbols.matic}` ||
         path === `/${ETokenSymbols.usdc}` ||
         path === `/${ETokenSymbols.usdce}`
}

export default isPageForClaim